import * as React from 'react';
import {useRoute} from 'react-router5';
import {CourseObject, getCourseByID} from 'api/course';
import useLoading from 'hooks/use-loading';
import CourseSchedule from 'components/CourseSchedule';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {Helmet} from 'react-helmet';

/**
 * The course program page
 * @constructor
 */
export default function CourseProgramPage(): React.ReactElement {
  const {route} = useRoute();
  const {fetch, data, render} = useLoading<CourseObject>();

  React.useEffect(() => {
    fetch(() => new Promise((resolve) => {
      return getCourseByID(route?.params?.id).then((response) => {
        validateResponse(response);

        if (response && !isError(response)) {
          resolve(response);
        }
      });
    }));
  }, []);

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return data ? (
      <CourseSchedule
        {...data}
      />
    ) : <React.Fragment />;
  }

  /**
   * Render not found.
   * @return {JSX.Element}
   */
  function renderNotFound(): JSX.Element {
    return (
      <div>
        Not found
      </div>
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Программа курса</title>
      </Helmet>
      {render(renderContent, renderNotFound)}
    </React.Fragment>
  );
}
